import loadable from '@loadable/component'

export const Box = loadable(() => import('./Box'))
export * from './Box'
export type {
  BoxHrefProps,
  BoxLinkProps,
  BoxButtonProps,
  BoxProps
} from './Box'
